var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppValidation',{attrs:{"rules":_vm.rules,"name":_vm.$attrs.name || _vm.$attrs.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-select',_vm._b({attrs:{"error-messages":errors},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-select',_vm.$attrs,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }